<template>
  <div>
    <SharedDialog class="dialog" width="800">
      <template #title>
        <p class="dialog__title">{{ messages.title }}</p>
      </template>
      <template #content>
        <p class="dialog__description" v-html="messages.description" />
      </template>
      <template #actions="{ closeDialog }">
        <div class="d-flex buttons">
          <BaseButton class="confirm-button" to="profile" @click="closeDialog">{{
            $t("missingDataReminder.button")
          }}</BaseButton>
        </div>
      </template>
    </SharedDialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      note: "",
      lesson_id: null,
    }
  },
  computed: {
    messages() {
      return {
        title: this.$t("missingDataReminder.title"),
        description: this.$t("missingDataReminder.description"),
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.dialog {
  &__title {
    font-weight: bold;
    font-size: 1.5rem;
    letter-spacing: 0.02em;
  }

  &__description {
    font-size: 0.875rem;
    margin: 1.5rem 0 0.5rem 0 !important;
  }
}
</style>
